import { render, staticRenderFns } from "./Sinistro.vue?vue&type=template&id=63314a02&"
import script from "./Sinistro.vue?vue&type=script&lang=js&"
export * from "./Sinistro.vue?vue&type=script&lang=js&"
import style0 from "./Sinistro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports